import { type User } from 'entities/Users/model/User'
import { type UserOwner } from 'entities/Users/model/UserOwner'

export enum EnumUserRoles {
  VIEW_ONLY = 'view_only',
  MEMBER = 'member',
  MANAGER = 'manager',
  ADMIN = 'admin',
  OWNER = 'owner',
}

export enum UserAccessRequestType {
  PermissionsUpdate = 1,
  InboxAccess = 2,
  SalesmsgAccess = 3,
}

export type IPermissionsContactAccess = 'can_access_all' | 'can_access_own' | 'can_access_groups'
export interface Permissions {
  billing: boolean
  broadcasts: boolean
  campaigns: boolean
  contactAccess: IPermissionsContactAccess
  contactCreate: boolean
  dataAndSecurity: boolean
  inbox: boolean
  manualOptIn: boolean
  members: boolean
  phoneChecker: boolean
  reportingAndAnalytics: boolean
  transferConversation: boolean
  textBot: boolean
  triggers: boolean
  cannedMessage: boolean
}

export type IUser = User | UserOwner
